import { Component } from '@angular/core';
@Component({
  selector: 'app-multiplegrid',
  templateUrl: './multiplegrid.component.html',
  styleUrl: './multiplegrid.component.scss'
})
export class MultiplegridComponent {
  columnDefs!:any[]
  rowData: any
  defaultColDef: any;
  gridColumnApi: any;
  constructor(){}
  ngOnInit(){
    this.columnDefs = [
      { headerName: "Payment Mode", field: "paymentType", with: "50px" },
      { headerName: "Client Name", field: "customerName" },
      { headerName: "Transaction No.", field: "transactionNumber", type: 'rightAligned' },
      { headerName: "Payment Date", field: "paymentDate", cellStyle: {textAlign: 'center'} },
      { headerName: "Amount", field: "amount", type: 'rightAligned' },

    ];

    this.rowData = [
      { paymentType: "Cash", customerName: "Plot", paymentDate: "15-03-2024", amount: 39000, transactionNumber: '9876543102', },
      { paymentType: "Cheque", customerName: "Flat", paymentDate: "30-03-2024", amount: 20000, transactionNumber: '9688563254', },

    ];
    this.defaultColDef = {
      editable: false,
      sortable: true,
      filter: true,
      resizable: false,
    };
  }

  // /**
  //  *
  //  * @param params
  //  */
  // onGridReady(params: GridReadyEvent) {
  //   this.gridApi = params.api;
  //   params.api.sizeColumnsToFit();
  //   this.gridColumnApi = params.columnApi;
  //   if (this.rowData?.length > 0)
  //     this.gridApi.setRowData(this.rowData);
  // }
}
